const Vision = () => {
  return (
    <article>
      <h2 className="text-[#408099] font-bold text-md md:text-lg lg:text-2xl mb-2 md:mb-4">
        الرؤية
      </h2>
      <p>التميز في ريادة العمل الاجتماعي والتنموي</p>
    </article>
  );
};
export default Vision;
